import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { conditionalValidator } from '../../validation/validation.helpers';
import { ImageInputEvent } from './image-input.types';

/**
 * @todo: Extract to service
 * This is why DI for. It simplifies testing.
 */
export const getLogoGroup = (fb: FormBuilder, data: ImageInputEvent | undefined, getFieldValue: CallableFunction): FormGroup => {

  const isLogoSelected = () => getFieldValue('logo.file');

  return fb.group({
    file: [data?.file],
    params: fb.group({
      size: [data?.params?.size, [Validators.max(500 * 1024)]],
      name: [data?.params?.name],
      height: [data?.params?.height, [
        conditionalValidator(isLogoSelected, Validators.min(100)),
        conditionalValidator(isLogoSelected, Validators.max(100)),
      ]],
      width: [data?.params?.width, [
        conditionalValidator(isLogoSelected, Validators.min(200)),
        conditionalValidator(isLogoSelected, Validators.max(200)),
      ]]
    }),
  });
};
